import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Row, Col } from 'react-bootstrap';
import { round } from 'lodash';
import label from '../../utils/lngEn';
import FormField from '../common/FormField';

const validate = values => {
  const errors = {};

  if (values.target_course_units && parseFloat(values.target_course_units) < 0) {
    errors.target_course_units = 'Must not be a negative number';
  } else if (
    parseFloat(values.max_course_units) &&
    round(parseFloat(values.target_course_units), 1) > round(parseFloat(values.max_course_units), 1)
  ) {
    errors.max_course_units = 'Target course units must be not be smaller than minimum course units';
  }
  return errors;
};

const GetStartedForm = props => {
  const { handleSubmit, progress, allow_min, allow_max, primary_contact } = props;
  return (
    <form onSubmit={handleSubmit} className="mt-6 mb-6">
      <Row>
        <Col md={4}>
          <Field
            name="target_course_units"
            type="number"
            component={FormField}
            label={label.getStartedForm_targetCredit_label}
            description={label.getStartedForm_targetCredit_desc}
            disabled={!allow_min}
          />
        </Col>
        <Col md={4}>
          <Field
            name="max_course_units"
            type="number"
            component={FormField}
            label={label.getStartedForm_maxCredit_label}
            description={label.getStarterForm_maxCredit_desc}
            disabled={!allow_max}
          />
        </Col>
      </Row>
      {!allow_min || !allow_max ? (
        <div className="input-description description-text mb-2">
          {label.disabledClassChangeDesc} <a href={`mailto:${primary_contact}`}>{primary_contact}</a>
        </div>
      ) : null}
      <button className="btn btn-primary mt-2" type="submit" disabled={progress || (!allow_min && !allow_max)}>
        {progress ? 'Saving...' : 'Save'}
      </button>
    </form>
  );
};

export default reduxForm({
  form: 'GetStartedForm',
  validate
})(GetStartedForm);



// WEBPACK FOOTER //
// ./src/components/rank/GetStartedForm.js